export default [
  {
    id: 'REGION',
    key: 'REGION',
    value: '地域',
    disabled: false
  },
  {
    id: 'GENDER',
    key: 'GENDER',
    value: '性别',
    disabled: false
  },
  {
    id: 'AGE',
    key: 'AGE',
    value: '年龄',
    disabled: false
  },
  {
    id: 'CUSTOM_AUDIENCE',
    key: 'CUSTOM_AUDIENCE',
    value: '自定人群-定向',
    disabled: false
  }
]
